import { render, staticRenderFns } from "./pdf-notes.html?vue&type=template&id=4837a6c0&scoped=true&"
import script from "./pdf-notes.js?vue&type=script&lang=js&"
export * from "./pdf-notes.js?vue&type=script&lang=js&"
import style0 from "./pdf-notes.scss?vue&type=style&index=0&id=4837a6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4837a6c0",
  null
  
)

export default component.exports